import letters from './letters';

// Newest letters first so the most recently archived appear at the top.
export const archives = [...letters].sort(
  (a, b) => new Date(b.dateArchived) - new Date(a.dateArchived)
);
